import { IconProps } from "./";
import Icon from "./assets/id_card_bold.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24IdCardBold(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
